import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReloadOutlined } from '@ant-design/icons';
import { Modal, Button, DatePicker, Row, Card } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { checkPermission } from '@/utils/permission';
import { cleanObject, telesaleFollowStatuses } from '@/utils/helpers';
import TelesaleFollowUpDetail from './TelesaleFollowUpDetail';
import BaseSelect from '@//components/Elements/BaseSelect';
import { getTelesaleFollowUps, getTelesaleFollowUp, removeTelesaleFollowUps, acceptTelesale, unacceptTelesale } from '@/redux/actions/telesaleFollowUpActions';
import { fetchFilters } from '@/redux/actions/filterActions';
import moment from 'moment';
import DynamicTable from '@/components/DynamicTable';
import StatisticNumber from '@/components/StatisticNumber';
import TelesaleManualResultForm from './TelesaleManualResultForm';
import TelesaleAssignedResultForm from './TelesaleAssignedResultForm';
import { telesaleFollowUpColumns } from './telesaleFollowUpColumns';

const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/telesale-follow-ups',
        breadcrumbName: 'Theo dõi telesale',
    },
]

class TelesaleFollowUpList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentItem: null,
            selectedRowKeys: [],
            openDetail: false,
            remainingTime: 0,
            openManualResult: false,
            openAssignedResult: false
        }

        this.permissions = {
            assign: checkPermission('telesale_follow_up', 'assign'),
            update: checkPermission('telesale_follow_up', 'update'),
            updateResult: checkPermission('telesale_follow_up', 'update_result'),
            remove: checkPermission('telesale_follow_up', 'delete')
        };


    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);

        this.intervalId = setInterval(() => {
            this.setState((prevState) => ({
                remainingTime: prevState.remainingTime + 1,
            }));
        }, 30000); // chạy mỗi 30 giây
        this.props.fetchFilters();
    }

    componentWillUnmount() {
        // Hủy interval khi component unmount
        clearInterval(this.intervalId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    loadData(queryParams = null) {
        this.setState({ isLoading: true });
        this.props.getTelesaleFollowUps(queryParams).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter = (name, value) => {
        const query = {
            ...qs.parse(this.props.location.search.slice(1)),
            [name]: value
        };

        const handleDateRange = (field) => {
            const fromKey = `${field}_from`;
            const toKey = `${field}_to`;

            if (value?.length === 2) {
                query[fromKey] = moment(value[0]).format('YYYY-MM-DD');
                query[toKey] = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query[fromKey];
                delete query[toKey];
            }

            delete query[field];
        };

        if (['created_at', 'handled_at'].includes(name)) {
            handleDateRange(name);
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(cleanObject(query))
        });
    };


    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    toggleDetail(openDetail, data = null) {
        this.setState({ openDetail: openDetail, currentItem: data });
    }

    onDetail(id) {
        this.props.getTelesaleFollowUp(id).then(res => {
            this.toggleDetail(true, res);
        })
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        const selectedCustomerIds = selectedRows.map(item => item.id);
        this.setState({ selectedRowKeys, selectedCustomerIds });
    };


    onRemove() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.props.removeTelesaleFollowUps(this.state.selectedRowKeys).then(() => {
            this.setState({ selectedRowKeys: [] });
            this.loadData(query);
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }

    openAssignedResult = async (id) => {
        try {
            // reset trước để tránh dữ liệu cũ
            this.setState({
                openAssignedResult: false,
                currentItem: null
            });

            const res = await this.props.getTelesaleFollowUp(id);
            this.setState({
                currentItem: res,
                openAssignedResult: true
            });
        } catch (error) {
            Modal.error({
                title: 'Không thể tải dữ liệu',
                content: 'Vui lòng thử lại hoặc liên hệ quản trị viên.',
            });
        }
    };

    closeAssignedResult() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.setState({
            openAssignedResult: false,
            openManualResult: false,
            currentItem: null,
            isLoading: false,
            selectedRowKeys: []
        })
    }


    openManualResult = () => {
        this.setState({
            openManualResult: true
        });
    };

    closeManualResult = () => {
        this.setState({
            openManualResult: false,
        });
    };

    handleAcceptTelesale = (id) => {
        Modal.confirm({
            title: 'Xác nhận tiếp nhận telesale',
            content: 'Bạn có chắc chắn muốn tiếp nhận telesale khách hàng này không?',
            okText: 'Tiếp nhận',
            cancelText: 'Hủy',
            okType: 'primary',
            onOk: () => {
                return this.props.acceptTelesale(id).then(() => {
                    const query = qs.parse(this.props.location.search.slice(1));
                    this.loadData(query);
                });
            }
        });
    }

    handleUnacceptTelesale = (id) => {
        Modal.confirm({
            title: 'Xác nhận hủy tiếp nhận',
            content: (
                <div>
                    <p>Khách hàng này có thể đã có kết quả telesale.</p>
                    <p>
                        <b>Lưu ý:</b> Hủy tiếp nhận <u>không xóa</u> kết quả telesale đã trả.
                    </p>
                </div>
            ),
            okText: 'Hủy tiếp nhận',
            cancelText: 'Quay lại',
            okType: 'danger',
            onOk: () => {
                return this.props.unacceptTelesale(id).then(() => {
                    const query = qs.parse(this.props.location.search.slice(1));
                    this.loadData(query);
                });
            }
        });
    }



    render() {
        var { telesaleFollowUps, pagination, customer_care_staff, filterData, statistical } = this.props;
        var {
            isLoading,
            currentItem,
            openAssignedResult,
            selectedRowKeys,
            openDetail,
            openManualResult
        } = this.state;

        var query = qs.parse(this.props.location.search.slice(1));

        const customerStatusActiveList = filterData?.statuses || [];

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        const columns = telesaleFollowUpColumns({
            permissions: this.permissions,
            onDetail: (id) => this.onDetail(id),
            openAssignedResult: (id) => this.openAssignedResult(id),
            authUser: this.props.authUser,
            acceptTelesale: (id) => this.handleAcceptTelesale(id),
            unacceptTelesale: (id) => this.handleUnacceptTelesale(id),
        });


        return (
            <div>
                <PageTitle routes={routes} title="Theo dõi telesale" />
                <div>
                    <TableActionBar
                        isShowAddButton={this.permissions.updateResult}
                        isShowDeleteButton={this.permissions.remove}
                        addText="Trả kết quả telesale"
                        onAdd={() => this.openManualResult()}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        filterColSpan={6}
                        activeFilter={
                            query.staff_id ||
                            query.accepted_by ||
                            query.follow_status ||
                            query.customer_status ||
                            query.mode ||
                            query.handled_at_from ||
                            query.created_at_from ||
                            query.accepted_status
                        }
                        filters={[
                            <BaseSelect
                                options={customer_care_staff || []}
                                optionValue="user_id"
                                optionLabel="display_name"
                                showSearch
                                placeholder="Nhận viên được phân công"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('staff_id', value)}
                                defaultValue={query.staff_id ? parseInt(query.staff_id) : null}
                            />,
                            <BaseSelect
                                options={customer_care_staff || []}
                                optionValue="user_id"
                                optionLabel="display_name"
                                showSearch
                                placeholder="Nhận viên tiếp nhận"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('accepted_by', value)}
                                defaultValue={query.accepted_by ? parseInt(query.accepted_by) : null}
                            />,
                            <BaseSelect
                                options={telesaleFollowStatuses || []}
                                optionValue="value"
                                optionLabel="label"
                                showSearch
                                placeholder="Trạng thái fllow"
                                onChange={(value) => this.onChangeFilter('follow_status', value)}
                                className="w-100"
                                defaultValue={query.follow_status ? query.follow_status : null}
                            />,
                            <BaseSelect
                                options={customerStatusActiveList || []}
                                optionValue="id"
                                optionLabel="name"
                                showSearch
                                placeholder="Trạng thái khách hàng"
                                onChange={(value) => this.onChangeFilter('customer_status', value)}
                                className="w-100"
                                defaultValue={query.customer_status ? parseInt(query.customer_status) : null}
                            />,
                            <BaseSelect
                                options={[
                                    { label: 'Được phân công', value: 'assigned' },
                                    { label: 'Chủ động', value: 'manual' }
                                ]}
                                placeholder="Hình thức telesale"
                                onChange={(value) => this.onChangeFilter('mode', value)}
                                className="w-100"
                                defaultValue={query.mode ? query.mode : null}
                            />,
                            <BaseSelect
                                options={[
                                    { label: 'Chưa tiếp nhận', value: 0 },
                                    { label: 'Đã tiếp nhận', value: 1 }
                                ]}
                                placeholder="Trạng thái tiếp nhận"
                                onChange={(value) => this.onChangeFilter('accepted_status', value)}
                                className="w-100"
                                allowClear
                                defaultValue={
                                    query.accepted_status !== undefined
                                        ? parseInt(query.accepted_status)
                                        : null
                                }
                            />,

                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Thời điểm telesale', 'Đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('handled_at', value)}
                                defaultValue={[query.handled_at_from ? moment(query.handled_at_from, 'YYYY-MM-DD') : null, query.handled_at_to ? moment(query.handled_at_to, 'YYYY-MM-DD') : null]}
                            />,
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày giao telesale', 'Đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('created_at', value)}
                                defaultValue={[query.created_at_from ? moment(query.created_at_from, 'YYYY-MM-DD') : null, query.created_at_to ? moment(query.created_at_to, 'YYYY-MM-DD') : null]}
                            />
                        ]}
                    >
                        <BaseSelect
                            options={[
                                { value: 1, label: 'Đã trả kết quả' },
                                { value: 0, label: 'Chưa trả kết quả' }
                            ]}
                            placeholder="Trạng thái"
                            style={{ width: '180px' }}
                            className="table-button"
                            onChange={(value) => this.onChangeFilter('telesale_status', value)}
                            defaultValue={query.telesale_status ? parseInt(query.telesale_status) : null}
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                    {
                        hasSelected ? <Row className="mb-2" align="middle">Đang chọn {selectedRowKeys.length} bản ghi </Row> : ''
                    }
                </div>

                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card className="customer-telesale-list-statistic">
                        <StatisticNumber
                            title="Đã trả kết quả"
                            value={statistical?.total_returned_results || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-telesale-list-statistic">
                        <StatisticNumber
                            title="Chưa trả kết quả"
                            value={statistical?.total_pending_results || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-telesale-list-statistic">
                        <StatisticNumber
                            title="Đúng hạn"
                            value={statistical?.total_on_time || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-telesale-list-statistic">
                        <StatisticNumber
                            title="Quá hạn"
                            value={statistical?.total_overdue || 0}
                            precision={0}
                        />
                    </Card>
                </Row>

                <div className='has-custom-column-table-btn'>
                    <DynamicTable
                        rowKey="id"
                        dataSource={telesaleFollowUps || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={rowSelection}
                        moduleKey="telesale_follow_up"
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                    />
                </div>

                <TelesaleFollowUpDetail
                    visible={openDetail}
                    currentItem={currentItem}
                    loadData={() => this.loadData(query)}
                    onCancel={() => this.toggleDetail(false)}
                />
                <TelesaleAssignedResultForm
                    visible={openAssignedResult}
                    currentItem={currentItem}
                    loadData={() => this.loadData(query)}
                    onCancel={() => this.closeAssignedResult()}
                />

                <TelesaleManualResultForm
                    visible={openManualResult}
                    loadData={() => this.loadData(query)}
                    onCancel={() => this.closeManualResult()}
                />
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        telesaleFollowUps: state.telesaleFollowUpReducer.telesaleFollowUps,
        pagination: state.telesaleFollowUpReducer.pagination,
        statistical: state.telesaleFollowUpReducer.statistical,
        customer_care_staff: state.config.customer_care_staff,
        authUser: state.auth.authUser,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getTelesaleFollowUps: (filter) => dispatch(getTelesaleFollowUps(filter)),
        getTelesaleFollowUp: (id) => dispatch(getTelesaleFollowUp(id)),
        removeTelesaleFollowUps: (id) => dispatch(removeTelesaleFollowUps(id)),
        fetchFilters: () => dispatch(fetchFilters()),
        acceptTelesale: (id) => dispatch(acceptTelesale(id)),
        unacceptTelesale: (id) => dispatch(unacceptTelesale(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TelesaleFollowUpList);

